import React from "react";

export const SummaryCardOnSaveContext = React.createContext<
  (() => void) | undefined
>(undefined);

export function useSummaryCardOnSave(): (() => void) | undefined {
  return React.useContext(SummaryCardOnSaveContext);
}
